import "./OrnateCurationServicesLegacyLens.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import LegacyLens from "./sections/LegacyLens";
import Footer from "@/reusable_sections/Footer";
export default function OrnateCurationServicesLegacyLensPage() {
  return <div>
      <Header />
      <Services />
      <LegacyLens />
      <Footer />
    </div>;
}